





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from "vuex";

@Component
export default class Transfer extends Vue {
    private loading = false;
    private unitTree = [];
    private selUnit: any = [];
    private unitId = 0;

    created() {
        this.reloadTree();
    }

    // 加载机构树
    reloadTree() {
        this.$apis.getAllUnitTree()
            .then((res: any) => {
                this.unitTree = res.data;
                this.unitId = this.$store.state.userInfo.unitId
                this.selUnit = [this.unitId];
            });
    }

    onUnitChange(data: any, checked: boolean, node: any) {
        if (checked === true) {
            this.unitId = data.id;
            (this.$refs.treeForm as any).setCheckedKeys([data.id]);
            console.log(data)
        } else {
            if (this.unitId == data.id) {
                (this.$refs.treeForm as any).setCheckedKeys([data.id]);
            }
        }
    }

    // 提交
    onSave() {
        this.$confirm('警告：每个月只能修改一次所属单位, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$apis.putUserTransfer2(this.unitId)
                .then((res: any) => {

                    this.$message({
                        type: 'success',
                        message: '提交成功，请重新登录!'
                    });

                    this.$store.state.token = null;
                    setTimeout(()=>{
                        this.$router.push("/login");
                    }, 2000);
                });
        });
    }
}
